const indexItems = [
  { title: '动作冒险专题', count: '326部', desc: '高燃打斗·惊险刺激', icon: 'ri-sword-line', color: 'bg-accent-100 text-accent-600' },
  { title: '科幻奇幻专题', count: '218部', desc: '想象无界·视觉盛宴', icon: 'ri-rocket-2-line', color: 'bg-primary-100 text-primary-600' },
  { title: '悬疑犯罪专题', count: '185部', desc: '烧脑推理·反转不断', icon: 'ri-search-eye-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '喜剧搞笑专题', count: '274部', desc: '爆笑解压·欢乐无限', icon: 'ri-emotion-happy-line', color: 'bg-accent-100 text-accent-600' },
  { title: '爱情文艺专题', count: '198部', desc: '浪漫心动·情感共鸣', icon: 'ri-heart-pulse-line', color: 'bg-primary-100 text-primary-600' },
  { title: '恐怖惊悚专题', count: '142部', desc: '极限刺激·胆量考验', icon: 'ri-ghost-smile-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '国产热剧专题', count: '467部', desc: '国剧精选·追更不停', icon: 'ri-tv-2-line', color: 'bg-accent-100 text-accent-600' },
  { title: '日韩精选专题', count: '352部', desc: '高分推荐·甜蜜上头', icon: 'ri-global-line', color: 'bg-primary-100 text-primary-600' },
  { title: '动漫番剧专题', count: '509部', desc: '热血二次元·应有尽有', icon: 'ri-movie-2-line', color: 'bg-secondary-100 text-secondary-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">专题合集</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">主题索引 · 分类探索</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">按类型快速浏览影视资源，每个专题精心挑选最值得看的优质内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group flex items-center gap-3 md:gap-4 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <span className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${item.color} transition-colors`}>
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-semibold text-sm md:text-base text-foreground-900 truncate whitespace-nowrap">{item.title}</h3>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.desc}</span>
                  <span className="text-xs font-semibold text-primary-500 whitespace-nowrap ml-auto">{item.count}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}